import { Component, Input } from '@angular/core';

import { Team } from '../../data/models/collections/team';

@Component({
  selector: 'placeme-team-card',
  templateUrl: './team-card.component.html',
  styleUrls: ['./team-card.component.scss'],
})
export class TeamCardComponent {
  @Input() team: Team;
}
